import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { TranslateModule } from '@ngx-translate/core';
import { HomeBannerComponent } from './home-banner/home-banner.component';
import { LimitedTimeDealsComponent } from './limited-time-deals/limited-time-deals.component';
import { HomeNewsletterSectionComponent } from './home-newsletter-section/home-newsletter-section.component';
import { NewsletterSearchComponent } from './newsletter-search/newsletter-search.component';
import { SharedComponentModule } from '../../../shared-component/shared-component.module';
import { ProductListComponent } from './product-list/product-list.component';
import { SingleProductComponent } from './product-list/single-product/single-product.component';
import { SwiperModule } from 'swiper/angular';
import { HomepageSpinnerModule } from 'src/app/shared-component/homepage-spinner/homepage-spinner.module';

export const route: Routes = [{ path: '', component: HomeComponent }];

@NgModule({
  declarations: [
    HomeComponent,
    HomeBannerComponent,
    LimitedTimeDealsComponent,
    HomeNewsletterSectionComponent,
    NewsletterSearchComponent,
    ProductListComponent,
    SingleProductComponent,
  ],
  imports: [
    TranslateModule,
    SharedComponentModule,
    SwiperModule,
    HomepageSpinnerModule,
    RouterModule.forChild(route),
  ],
})
export class HomeModule {}
